<template>
  <LayoutOneColumn>
    <div class="flex flex-col gap-4">
      <!-- sm:px-1 for vsisible focus styles -->
      <div
        class="flex gap-2 px-2 overflow-x-scroll max-w-full py-1 md:flex-wrap"
      >
        <SidebarMenuItem
          v-for="section in menu"
          :key="section.id"
          :item="section"
          theme="white"
        />
      </div>
      <NuxtPage />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { useEvents } from '~/stores/events'

const eventsStore = useEvents()
const menu = eventsStore.getSectionList()
</script>
